module.exports = __webpack_public_path__ + "img/active-list6.9365c885.png";